"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftMapper = exports.crewMapper = exports.contactPersonMapper = exports.childMapper = void 0;
const child_1 = require("../models/child");
const contact_person_1 = require("../models/contact-person");
const crew_1 = require("../models/crew");
const shift_1 = require("../models/shift");
exports.childMapper = {
    lift(id, obj) {
        return new child_1.Child(Object.assign({ id }, obj));
    },
    unlift(child) {
        const { id } = child, obj = __rest(child, ["id"]);
        return obj;
    },
};
exports.contactPersonMapper = {
    lift(id, obj) {
        return new contact_person_1.ContactPerson(Object.assign({ id }, obj));
    },
    unlift(contactPerson) {
        const { id } = contactPerson, obj = __rest(contactPerson, ["id"]);
        return obj;
    },
};
exports.crewMapper = {
    lift(id, obj) {
        return new crew_1.Crew(Object.assign({ id }, obj));
    },
    unlift(crew) {
        const { id } = crew, obj = __rest(crew, ["id"]);
        return obj;
    },
};
exports.shiftMapper = {
    lift(id, obj) {
        return new shift_1.Shift(Object.assign({ id }, obj));
    },
    unlift(shift) {
        const { id } = shift, obj = __rest(shift, ["id"]);
        return obj;
    },
};
//# sourceMappingURL=mappers.js.map